import * as S from "./styles";
import { SideFilters } from "../SideFilters";
import { MdExpandLess, MdOutlineExpandMore } from "react-icons/md";
import { useTheme } from "styled-components";
import { useState } from "react";
import { FilterDetails } from "../FilterDetails";
import { ExploreTable } from "../ExploreTable";

export function DynamicReportMobile() {
  const [contentSelected, setContentSelected] = useState<
    "filters" | "selectedFilters" | "table" | ""
  >("");

  const { newColors } = useTheme();

  const handleSelectContent = (content: typeof contentSelected) => {
    if (contentSelected === content) return setContentSelected("");

    return setContentSelected(content);
  };

  return (
    <S.Container>
      <S.SectionContent isSelected={contentSelected === "filters"}>
        <S.SectionButtonContainer>
          <S.ContentButton onClick={() => handleSelectContent("filters")}>
            Filters
          </S.ContentButton>

          {contentSelected === "filters" ? (
            <MdExpandLess
              size={24}
              color={newColors["gray-525"]}
              onClick={() => handleSelectContent("filters")}
            />
          ) : (
            <MdOutlineExpandMore
              size={24}
              color={newColors["gray-525"]}
              onClick={() => handleSelectContent("filters")}
            />
          )}
        </S.SectionButtonContainer>

        {contentSelected === "filters" && (
          <SideFilters handleContentSelected={setContentSelected} />
        )}
      </S.SectionContent>

      <S.SectionContent
        style={{
          paddingBottom: contentSelected === "selectedFilters" ? 16 : 0,
        }}
      >
        <S.SectionButtonContainer>
          <S.ContentButton
            onClick={() => handleSelectContent("selectedFilters")}
          >
            Selected Filters
          </S.ContentButton>

          {contentSelected === "selectedFilters" ? (
            <MdExpandLess
              size={24}
              color={newColors["gray-525"]}
              onClick={() => handleSelectContent("selectedFilters")}
            />
          ) : (
            <MdOutlineExpandMore
              size={24}
              color={newColors["gray-525"]}
              onClick={() => handleSelectContent("selectedFilters")}
            />
          )}
        </S.SectionButtonContainer>

        {contentSelected === "selectedFilters" && (
          <FilterDetails handleContentSelected={setContentSelected} />
        )}
      </S.SectionContent>

      <S.SectionContent>
        <S.SectionButtonContainer>
          <S.ContentButton onClick={() => handleSelectContent("table")}>
            Table
          </S.ContentButton>

          {contentSelected === "table" ? (
            <MdExpandLess
              size={24}
              color={newColors["gray-525"]}
              onClick={() => handleSelectContent("table")}
            />
          ) : (
            <MdOutlineExpandMore
              size={24}
              color={newColors["gray-525"]}
              onClick={() => handleSelectContent("table")}
            />
          )}
        </S.SectionButtonContainer>
        {contentSelected === "table" && <ExploreTable />}
      </S.SectionContent>
    </S.Container>
  );
}
